// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c90f4365","453":"230f6e55","455":"08ba8661","977":"a864f9a1"}[chunkId] + ".chunk.js";
};